import gql from 'graphql-tag'

export default gql`
    fragment PageSliderBlock on PageSliderBlock {
        type
        references {
            __typename
            ... on Page {
                type
                id
                url
                brand {
                    id
                    logo
                    title
                }
                openGraph {
                    title
                    description
                    imageURL
                }
            }
        }
        showDescription
    }
`
